export interface CohortDetail {
  /** The initial name of the cohort */
  name: string;

  /** The initial description of the cohort */
  description: string;

  /** The type of the cohort */
  type: string;

  /** The warning to be displayed in the modal */
  warning: string;
}

export enum VIEWS {
  CREATE_COHORT = `create-cohort`,
  BREAKDOWN = `breakdown`,
  POPOVER = `popover`,
}
